<template>
  <div v-if="isShow()">
    <div class="row">
      <label class="form-label" v-if="hasPath()">
        Полный путь: {{ fields.path }}
      </label>
      <label class="form-label" v-if="hasSlug()">
        Ссылка на сайт: <a target="_blank" :href="getUrlSite() + '/catalog/category/' + fields.slug">{{ fields.slug }}</a>
      </label>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import cfg from "@/services/Config"

export default defineComponent({
  name: "Info",
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    let show = ref(false)
    let fields = reactive({
      slug: null,
      path: null,
    })
    const urlSite = cfg._("base", "url_site")

    onMounted(async () => {
      markUnshow()

      await updateFields(props.payload)

      markShow()
    })

    async function updateFields(query) {
      fields.slug = query.slug
      fields.path = query.path
    }

    function getUrlSite() {
      return urlSite
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function hasSlug() {
      return fields.slug !== null && fields.slug !== undefined
    }

    function hasPath() {
      return fields.path !== null && fields.path !== undefined
    }

    return {
      isShow,
      fields,
      hasSlug,
      hasPath,
      getUrlSite,
    }
  }
})
</script>
